<template>
    <div class="content-container ipad">
        <Navbar></Navbar>
        <!-- Content section -->
        <!-- <div class="container h-100 overlay overlay-dark-blues">
            


            <div class="homepage-disclaimer" v-html="homepageDisclaimer"></div>
        </div> -->

        <Approval v-if="this.isIpad"></Approval>

        <Slider></Slider>

        <Disclaimer timeline="false"></Disclaimer>
        <ReusableDisclaimer :params="disclaimerParams" @accepted="onAccepted"></ReusableDisclaimer>
    </div>
</template>

<script>

import Disclaimer from './components/DisclaimerModal.vue';
import ReusableDisclaimer from './components/ReusableDisclaimerModal.vue';
import Approval from './components/Approval.vue';
import Slider from "./components/ui/Slider.vue";
import Navbar from './components/ui/Navbar.vue';

export default {
    name: 'Index',
    components: {
        Disclaimer,
        ReusableDisclaimer,
        Approval,
        Slider,
        Navbar,
    },
    data: function () {
        return {
            searchInput: false,
            disclaimers: {
                'hcp_confirmation': null
            },
            disclaimerParams: null,
        }
    },
    computed: {
        homepageDisclaimer: function () {
            return this.$store.getters.getEventDisclaimer;
        },
    },
    created: function () {
        /* If viewing on a screen greater than 1920, then redirect straight to timeline. */
        if (!this.$store.getters.getIndexRedirect) {
            if (window.localStorage.getItem('appHomepageStatus') !== null) {
                this.$router.push({
                    path: '/timeline'
                });

                this.$store.dispatch('setIndexRedirect');
            }
        }
        this.populateHcpConfirmationDisclaimer();
        this.disclaimerParams = this.disclaimers['hcp_confirmation'];
    },
    methods: {
        getId(button) {
            const id = button.getAttribute('data-event').toLowerCase();
            return id.replace(/\s/g, '_');
        },
        getDisclaimerJson() {
            let disclaimerStates = window.sessionStorage.getItem('reusableDisclaimerStates');
            return !disclaimerStates ? {} : JSON.parse(disclaimerStates);
        },
        populateHcpConfirmationDisclaimer: function () {
            const content = this.$store.getters.getDisclaimerContent;
            if (content && content.title[0].value && content.body[0].value) {
                this.disclaimers['hcp_confirmation'] = {
                    id: 'hcp_confirmation',
                    title: content.title[0].value,
                    body: content.body[0].value,
                    button: 'Continue'
                };
            }
        },
        checkDisclaimer(event) {
            const id = this.getId(event.target);
            const disclaimer = this.disclaimers[id];
            console.log(id);
            let disclaimerStates = this.getDisclaimerJson();
            if (disclaimerStates[id]) {
                console.log(event.target);
                this.$router.push(disclaimer['route']);
            } else {
                this.disclaimerParams = disclaimer;
            }
        },
        resetSearch(event) {
            let parent = event.target.closest('.app-form');
            let inp = parent.querySelector('input[type="text"]');
            inp.value = '';
            inp.focus();
        },
        submitForm: function () {
            let el = document.getElementById('search');
            let value = el.value;

            this.analytics.trackGoal(
                this.$router.currentRoute.path,
                'Search',
                value
            );

            this.$router.push({
                path: '/search-results/' + value
            })
        },
        trackEvent: function (event) {
            this.analytics.trackEvent(this.$router.currentRoute.path, 'navigation', event.target);
        },
        onAccepted: function () {
            // const disclaimer = this.disclaimerParams;
            this.disclaimerParams = null;

            if (this.disclaimerParams['route']) {
                this.$router.push(this.disclaimerParams['route']);
            }
        }
    }
}
</script>

<style scoped>
.visually-hidden {
    /* https://snook.ca/archives/html_and_css/hiding-content-for-accessibility */
    position: absolute !important;
    height: 1px;
    width: 1px;
    overflow: hidden;
    clip: rect(1px 1px 1px 1px);
    /* IE6, IE7 */
    clip: rect(1px, 1px, 1px, 1px);
}

.home-content h1 {
    font-size: 3.5em;
}

.home-content h2 {
    font-size: 1.5em;
}

.strong {
    font-weight: bold;
}

.homepage-disclaimer {
    width: 360px;
    max-width: 35%;
    font-size: 0.75em;
    line-height: 1.2em;
    color: white;
}

@media (min-width: 1920px) {
    .homepage-disclaimer {
        width: 434px;
    }
}
</style>
